<template>
  <div id="trendList">
    <div class="list-img">
      <img src="../../assets/images/banner.png"/>
    </div>
    <div class="list-content" v-show="trends.showTrend0">
      <h1>新闻动态</h1>
      <div class="list-item list-item-first">
        <h3>【双喜临门】我们搬家了</h3>
        <h5>2018-11-22</h5>
        <p style="overflow: hidden;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;" @click="showDetail(4)">
          今天是感恩节，值此佳节，恭祝江苏朗拓健康科技有限公司乔迁之喜！让我们在新的城池继续开疆扩土！公司经过快速且稳健的发展，运营规模不断扩大，员工逐渐增加，原办公地点已不能满足发展需求，本次搬迁对朗拓而言，是一个新的里程碑，更是个全新的开始！在这里，遇见，不早，不晚。在这里，没有我，只有我们。除了汗水，还有欢笑。除了奔跑，还有牵挂。有付出，有收获，还有满满的祝福只因我们都在这里。
        </p>
      </div>
      <div class="list-item">
        <h3>【号外】朗拓健康携“互联网+医疗健康服务闭环建设之处方共享”解决方案同步亮相多个学术高峰论坛</h3>
        <h5>2018-10-29</h5>
        <p style="overflow: hidden;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;" @click="showDetail(3)">
          2018 中国研究型医院学会移动医疗专业委员会年会暨第五届"互联网+医疗"学术高峰论坛于2018年10月26日-28日在江苏南京成功召开。“中国数字医学前沿论坛—互联网+医疗服务模式创新及网络安全”于2018年10月26日-28日在福建省福州市同步举办。朗拓健康携“互联网+医疗健康服务闭环建设之处方共享”全解决方案强势亮相双会。第五届全国“互联网+医疗”学术高峰论坛以“创新驱动，科技引领”为主题，设有主题报告、圆桌论坛、成果转化、产品展示四种交流形式。
        </p>
      </div>
      <div class="list-item">
        <h3>药迅处方共享平台亮相互联网+医联体模式下三级医院信息化建设现场会</h3>
        <h5>2018-08-06</h5>
        <p style="overflow: hidden;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;" @click="showDetail(2)">
          2018年8月4日，互联网+医联体模式下三级医院信息化建设现场会在连云港市第一人民医院隆重举行！江苏朗拓健康科技有限公司作为本次会议的受邀厂商，展出了公司倾力打造的拳头产品--药迅处方共享平台!药迅处方共享平台是江苏朗拓紧跟中国医改新政，结合医药市场动态推出的拳头产品。平台致力于应用国际先进的PBM（医药福利管理）模式与技术，专注于中国医药与大健康产业，为处方流转提供了综合性解决方案和软件平台。
        </p>
      </div>
      <div class="list-item">
        <h3>互联网诊疗管理办法（试行）</h3>
        <h5>2018-07-29</h5>
        <p style="overflow: hidden;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;" @click="showDetail(1)">
          第一条 为落实《国务院办公厅关于促进“互联网+医疗健康”发展的意见》，规范互联网诊疗活动，推动互联网医疗服务健康快速发展，保障医疗质量和医疗安全，根据《执业医师法》、《医疗机构管理条例》等法律法规，制定本办法。第二条 本办法所称互联网诊疗是指医疗机构利用在本机构注册的医师，通过互联网等信息技术开展部分常见病、慢性病复诊和“互联网+”家庭医生签约服务。第三条 国家对互联网诊疗活动实行准入管理。
        </p>
      </div>
    </div>
    <Trend1 v-if="trends.showTrend1"></Trend1>
    <Trend2 v-if="trends.showTrend2"></Trend2>
    <Trend3 v-if="trends.showTrend3"></Trend3>
    <Trend4 v-if="trends.showTrend4"></Trend4>
  </div>
</template>

<script  type="text/javascript">
  import Trend1 from './Trend1'
  import Trend2 from './Trend2'
  import Trend3 from './Trend3'
  import Trend4 from './Trend4'
  export default {
    components:{Trend1,Trend2,Trend3,Trend4},
    data () {
      return {
        index: 0,
        trends: {},
      }
    },
    mounted () {
      this.init()
    },
    destroyed () {
    },
    methods:{
      init(){
        this.trends = {}
        this.$set(this.trends,"showTrend"+this.index,true)
      },
      showDetail(index){
        this.trends = {}
        this.$set(this.trends,"showTrend"+index,true)
        window.scrollTo(0,0)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/trend/TrendList.vue